import type { OnboardingIcpId } from "@/lib/types/onboarding-goal"

/**
 * The marketing site asks one question before signup (humblytics.com/get-started)
 * and forwards the answer as `fit` on /auth; acquisitionContext stores it. It
 * only pre-selects the ICP step: the user still confirms or changes it.
 */
const ICP_FROM_FIT: Record<string, OnboardingIcpId> = {
  growth: "marketing_team",
  agency: "agency",
  scale: "marketing_team",
  early: "founder",
}

export function icpFromLandingFit(fit: string | undefined | null): OnboardingIcpId | null {
  return fit && Object.prototype.hasOwnProperty.call(ICP_FROM_FIT, fit) ? ICP_FROM_FIT[fit] : null
}
